var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25449 10.004L9.16422 11.9212C9.53616 12.1663 9.99795 11.8018 9.88758 11.3502L9.04689 7.9109C9.02322 7.8151 9.02602 7.71431 9.05498 7.6201C9.08394 7.52589 9.13788 7.44209 9.2106 7.37834L11.8199 5.11974C12.1627 4.82296 11.9858 4.23121 11.5453 4.20148L8.13774 3.97148C8.04595 3.96466 7.95792 3.93087 7.8839 3.87403C7.80987 3.8172 7.75289 3.73966 7.71959 3.65045L6.44872 0.322067C6.41418 0.227378 6.35275 0.145858 6.27261 0.0883328C6.19246 0.030808 6.09738 0 6 0C5.90262 0 5.80754 0.030808 5.7274 0.0883328C5.64725 0.145858 5.58583 0.227378 5.55128 0.322067L4.28041 3.65045C4.24712 3.73966 4.19014 3.8172 4.11611 3.87403C4.04208 3.93087 3.95405 3.96466 3.86227 3.97148L0.454732 4.20148C0.0142477 4.23121 -0.16271 4.82296 0.180137 5.11974L2.7894 7.37834C2.86212 7.44209 2.91606 7.52589 2.94502 7.6201C2.97398 7.71431 2.97678 7.8151 2.95311 7.9109L2.17347 11.1005C2.04102 11.6423 2.59517 12.0797 3.0415 11.7856L5.74552 10.004C5.82157 9.95361 5.90985 9.92687 6 9.92687C6.09015 9.92687 6.17843 9.95361 6.25449 10.004Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0515151696c19d3b2771a8f7b8addf0a.svg";
export { ForwardRef as ReactComponent };